import React from 'react';
import { connect } from 'react-redux'

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import { TextFieldHelper } from '../../Components/Fields';
import { doPost } from '../../Redux/Actions'
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

const ENDPOINT = "zeitraum"

export const Fields = ({handleChange, name, kuerzel, position}) => (
    <Grid container spacing={8}>

        <TextFieldHelper n={12} value={name} onChange={handleChange('name')} label="Name" helper={"Beispiel: Montag - Freitag"} />
                    
        <Grid item xs={12}><Divider /></Grid>
        <TextFieldHelper n={4} value={kuerzel} onChange={handleChange('kuerzel')} label="Kürzel" helper="Beispiel: Mo-Fr" />
        <TextFieldHelper n={6} value={position} onChange={handleChange('position')} type="number" label="Position" helper="Position von links nach rechts auf dem Ausdruck des Fahrplan" />

    </Grid>
)

class NewEntry extends Master {

	state = {
		newEntry: {}
	}

	render() {

		var {
			handleClickOpen, dialogOpen
		} = this.props

        var {
        	newEntry
        } = this.state

		return (
			<Dialog
                title="Neuer Zeitraum"
                saveAction={this.postData}
                closeAction={handleClickOpen}
                open={dialogOpen}
             >
				<Fields handleChange={this.handleChange} {...newEntry} />
			</Dialog>
		)
	}

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doPost: (data) => dispatch(doPost(ENDPOINT, "api/generic/" + ENDPOINT, data)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewEntry);


// WEBPACK FOOTER //
// ./src/Routes/Zeitraum/NewEntry.js